import { isAudioNode } from './audio-node';
export const isAudioNodeOutputConnection = (outputConnection) => {
    return isAudioNode(outputConnection[0]);
};
//# sourceMappingURL=audio-node-output-connection.js.map